import BigNumber from "bignumber.js";
import { useEffect, useState } from "react";
import { api } from "../../../../../api";
import { actions, useAppDispatch, useAppSelector } from "../../../../../redux";
import { toast } from "../../../../../toasts";

type Rewards = {
  soil: string;
  usdc: string;
};

export const useFetchAmountOfRewards = () => {
  const [userRewards, setUserRewards] = useState<Rewards | null>(null);
  const [lastUserPoolRewards, setLastUserPoolRewards] =
    useState<Rewards | null>(null);

  const stakingRewardsEarned = useAppSelector(
    (state) => state.staking.rewardsEarned
  );

  const lastStakingRewards = useAppSelector(
    (store) => store.staking.lastRewards
  );
  const isLogged = useAppSelector((store) => store.user.isLogged);

  const fetchUserRewards = async () => {
    try {
      const {
        data: { rewards, lastRewardAmount },
      } = await api.pools.getRewardsAmount();
      setUserRewards(rewards);
      setLastUserPoolRewards(lastRewardAmount);
    } catch (e: unknown) {
      toast.errorHandler(e, "Failed to fetch amount of user's rewards");
    }
  };

  const dispatch = useAppDispatch();

  const refreshRewards = () => {
    fetchUserRewards();
    if (isLogged) {
      dispatch(actions.staking.refreshStakingData());
    }
  };

  useEffect(() => {
    if (isLogged) {
      fetchUserRewards();
    } else {
      setUserRewards({
        soil: "0",
        usdc: "0",
      });
    }
  }, [isLogged]);

  const soilRewards =
    userRewards?.soil &&
    new BigNumber(userRewards?.soil).plus(stakingRewardsEarned || 0).toString();

  const lastUserRewards = lastUserPoolRewards
    ? {
        usdc: lastUserPoolRewards.usdc,
        soil: new BigNumber(lastStakingRewards)
          .plus(lastUserPoolRewards?.soil || "0")
          .toString(),
      }
    : null;

  return {
    usdcRewards: userRewards?.usdc,
    soilRewards,
    lastUserRewards,
    refreshRewards,
  };
};
